<template>
  <div @click="clickIcon">
    <svg class="icon-circle">
      <use v-bind="{'href':'#icons_' + nameIcon}" />
    </svg>
  </div>
</template>

<script>
export default {
  props: ["nameIcon", "size"],
  methods: {
    clickIcon() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>